module.exports = __webpack_public_path__ + "img/KP.26c75cdc.png";